import { v4 as uuidv4 } from 'uuid';
/**
 * Check if local storage is available for use
 * Returns false if the browser does not support local storage, local storage is full, or the user has disabled it
 */
const isLocalStorageAvailable = () => {
	try {
		const key = uuidv4();
		localStorage.setItem(key, key);
		localStorage.removeItem(key);
		return true;
	} catch (e) {
		return false;
	}
};

export default isLocalStorageAvailable;
